// mutations
const SET_USERDATA = (state, payload) => {
  state.UserData = payload;
};

const SET_DETAILEMERGENCY = (state, payload) => {
  state.dataemergency = payload;
};
const SET_ADDDATAUSER = (state, payload) => {
  state.addDataUser = payload;
};
const SET_DETAILUSER = (state, payload) => {
  state.detailUser = payload;
};
const SET_USERID = (state, payload) => {
  state.userId = payload;
};
const SET_SEARCHUSER = (state, payload) => {
  state.searchUser = payload;
};
const SET_USERIDUPDATE = (state, payload) => {
  state.idupdate = payload;
};
const SET_DATAPERSON = (state, payload) => {
  state.dataPerson = payload;
};
const SET_DATAPOSTEMER = (state, payload) => {
  state.datepostemergency = payload;
};
const SET_RESOTHERINFO = (state, payload) => {
  state.resOtherInfo = payload;
};
const SET_POSTOTHER = (state, payload) => {
  state.dataOtherPost = payload;
};
const SET_RESFAMILY = (state, payload) => {
  state.resFamily = payload;
};
const SET_FAMILYUPDATE = (state, payload) => {
  state.dataFamily = payload;
};
const SET_RESULTCUTI = (state, payload) => {
  state.resultCuti = payload;
};
const SET_DATASEARCH = (state, payload) => {
  state.search = payload;
};
const SET_RESLOCATION = (state, payload) => {
  state.list_location = payload;
};
const SET_RESLOC = (state, payload) => {
  state.res_loc = payload;
};
const SET_IDLOC = (state, payload) => {
  state.idLoc = payload;
};
// location
const SET_RESPROVINCE = (state, payload) => {
  state.listProvinsi = payload;
};
const SET_RESCITY = (state, payload) => {
  state.listCity = payload;
};
const SET_RESDISTRICT = (state, payload) => {
  state.listDistrict = payload;
};
const SET_RESSUBDISTRICT = (state, payload) => {
  state.listSubDistrict = payload;
};
// location1
const SET_RESPROVINCE1 = (state, payload) => {
  state.listProvinsi1 = payload;
};
const SET_RESCITY1 = (state, payload) => {
  state.listCity1 = payload;
};
const SET_RESDISTRICT1 = (state, payload) => {
  state.listDistrict1 = payload;
};
const SET_RESSUBDISTRICT1 = (state, payload) => {
  state.listSubDistrict1 = payload;
};
//
const SET_PROVINSI = (state, payload) => {
  state.provinsi = payload;
};
const SET_CITY = (state, payload) => {
  state.city = payload;
};
const SET_DISCTRICT = (state, payload) => {
  state.district = payload;
};
const SET_CONDITION = (state, payload) => {
  state.condition = payload;
};
export default {
  SET_RESULTCUTI,
  SET_FAMILYUPDATE,
  SET_DATAPOSTEMER,
  SET_USERDATA,
  SET_DETAILEMERGENCY,
  SET_ADDDATAUSER,
  SET_DETAILUSER,
  SET_USERID,
  SET_SEARCHUSER,
  SET_USERIDUPDATE,
  SET_DATAPERSON,
  SET_RESOTHERINFO,
  SET_POSTOTHER,
  SET_RESFAMILY,
  SET_DATASEARCH,
  SET_RESLOCATION,
  SET_RESLOC,
  SET_IDLOC,
  SET_RESPROVINCE,
  SET_RESCITY,
  SET_RESDISTRICT,
  SET_RESSUBDISTRICT,
  SET_RESPROVINCE1,
  SET_RESCITY1,
  SET_RESDISTRICT1,
  SET_RESSUBDISTRICT1,
  SET_PROVINSI,
  SET_CITY,
  SET_DISCTRICT,
  SET_CONDITION
};
